import * as api from '../../api/api-emision-pagos-cias';
import {
    GET_PAGOS_APROBADOS,
    GET_ESTADO_EMISION_PAGOS,
    POST_EMITE_PAGOS,
    POST_SUBIR_CUPON_EMISION,
    POST_NOTIFICAR_CIA_EMISION,
    GET_OPCIONES_REVERSA,
    POST_REVERSA_RESPUESTA
} from '../types';

export const buscarPagosAprobadosAction = (query) => ({
    type: GET_PAGOS_APROBADOS,
    payload: api.serviceBuscarPagosAprobados(query)
});

export const obtenerEstadoEmisionAction = (query) => ({
    type: GET_ESTADO_EMISION_PAGOS,
    payload: api.serviceObtenerEstadoEmision(query)
});

export const emitirPagosAction = (body) => ({
    type: POST_EMITE_PAGOS,
    payload: api.serviceEmitirPagos(body)
});

export const subirCuponAction = (body) => ({
    type: POST_SUBIR_CUPON_EMISION,
    payload: api.serviceSubirCupon(body)
});

export const notificarCiaAction = (body) => ({
    type: POST_NOTIFICAR_CIA_EMISION,
    payload: api.serviceNotificarCia(body)
});

export const obtenerOpcionesReversaAction = (body) => ({
    type: GET_OPCIONES_REVERSA,
    payload: api.serviceObtenerOpcionesReversa(body)
});

export const reversarRespuestaAction = (body) => ({
    type: POST_REVERSA_RESPUESTA,
    payload: api.serviceReversarRespuesta(body)
});
